import React, { useState, useEffect } from 'react'
import Img from 'gatsby-image'
import HubspotForm from 'react-hubspot-form'

import Link from '../Link'

import useMarketo from '../../hooks/useMarketo'

import {
  eventContainer,
  eventWrapper,
  backgroundImage,
  eventTitle,
  eventSubtitle,
  eventDescription,
  eventImage,
  eventFormBox,
  divider,
  eventCTA,
} from './index.module.css'

const Event = ({ images, events, contactForm_ref, backgroundColor }) => {
  const image = images ? images?.[0] : []
  const event = events ? events[0] : []
  const { formId, portalId, loadingText, webinarKey, marketoId, redirect } =
    contactForm_ref

  const [loading, setLoading] = useState(true)
  useMarketo({
    baseUrl: '//893-FVD-854.mktoweb.com',
    munchkinId: marketoId,
    formId: formId,
    callback: () => {
      setLoading(false)
    },
    redirect: redirect,
  })

  return (
    <div
      className={eventContainer}
      style={{ backgroundColor: backgroundColor || '#3C3C3C' }}
    >
      {image && (
        <Img
          className={backgroundImage}
          fluid={image?.fluid}
          imgStyle={{
            objectFit: 'cover',
            objectPosition: '50% 50%',
          }}
          alt={image?.description || ''}
        />
      )}
      <div
        className={eventWrapper}
        style={{
          backgroundColor: backgroundColor || '#3C3C3C',
          marginTop: image ? -300 : 0,
        }}
      >
        {event?.ctaUrl ? (
          <Link to={event?.ctaUrl}>
            <h1 className={eventTitle}>{event?.title}</h1>
          </Link>
        ) : (
          <h1 className={eventTitle}>{event?.title}</h1>
        )}
        {event?.subtitle && (
          <h4 className={eventSubtitle}>{event?.subtitle.subtitle}</h4>
        )}
        {event?.ctaUrl && event?.ctaText && (
          <Link to={event?.ctaUrl} className={eventCTA}>
            {event?.ctaText}
          </Link>
        )}
        {event?.description && (
          <div
            className={eventDescription}
            dangerouslySetInnerHTML={{
              __html: event?.description?.childMarkdownRemark?.html,
            }}
          />
        )}
        {event?.image && (
          <>
            {event?.ctaUrl ? (
              <Link to={event?.ctaUrl}>
                <Img
                  className={eventImage}
                  fluid={event?.image?.fluid}
                  imgStyle={{
                    objectFit: 'cover',
                    objectPosition: '50% 50%',
                  }}
                  alt={event?.image?.description || ''}
                />
              </Link>
            ) : (
              <Img
                className={eventImage}
                fluid={event?.image?.fluid}
                imgStyle={{
                  objectFit: 'cover',
                  objectPosition: '50% 50%',
                }}
                alt={event?.image?.description || ''}
              />
            )}
          </>
        )}

        {contactForm_ref && marketoId ? (
          <div className="hubspotForm">
            <div className={divider}></div>
            {formId && (
              <>
                <div style={{ display: loading ? 'flex' : 'none' }}>
                  {loadingText ? loadingText : 'Loading'}
                </div>

                <form id={`mktoForm_${formId}`} />
              </>
            )}
          </div>
        ) : (
          portalId &&
          formId &&
          loadingText && (
            <div className="hubspotForm">
              <div className={divider} />
              <form className={eventFormBox} noValidate autoComplete="off">
                {webinarKey ? (
                  <HubspotForm
                    portalId={portalId}
                    formId={formId}
                    goToWebinarWebinarKey={webinarKey}
                    loading={<div>{loadingText}</div>}
                  />
                ) : (
                  <HubspotForm
                    portalId={portalId}
                    formId={formId}
                    loading={<div>{loadingText}</div>}
                  />
                )}
              </form>
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default Event
